import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    studentInfo: JSON.parse(localStorage.getItem('student_info') || '{}'),
    token: localStorage.getItem('student_token') || ''
  },
  mutations: {
    SET_STUDENT_INFO(state, info) {
      state.studentInfo = info
      localStorage.setItem('student_info', JSON.stringify(info))
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('student_token', token)
    },
    LOGOUT(state) {
      state.studentInfo = {}
      state.token = ''
      localStorage.removeItem('student_info')
      localStorage.removeItem('student_token')
    }
  },
  actions: {
    login({ commit }, { token, studentInfo }) {
      commit('SET_TOKEN', token)
      commit('SET_STUDENT_INFO', studentInfo)
    },
    logout({ commit }) {
      commit('LOGOUT')
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    studentInfo: state => state.studentInfo
  }
})
